import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import SearchBars from 'components/SearchBars';
import { observable } from 'mobx';
import { observer, inject } from 'mobx-react';
import EquipmentsTable, { EQUIPMENT_COLUMNS, EQUIPMENT_CARDS, EQUIPMENT_MIN_TABLE_WIDTH } from 'components/Tables/Equipments';
import * as DataList from 'components/DataList';
import Card from 'components/Card';
import Sticky from 'react-stickynode';
import styled from '@emotion/styled';

const PageWrapGray = styled('div')`
  padding: 12px;
  background-color: #F8FAFB;
  min-height: calc(100vh - 75px);  
`

@inject('store', 'equipmentStore', 'viewStore') @observer
class EquipmentsIndexPage extends Component {

  @observable visible = true;

  render() {
    let content;
    let {
      equipmentStore: {
        equipments: {
          isLoading,
          isError
        }
      }
    } = this.props;
    if (isLoading && !isError) {
      content = (
        <DataList.Loading
          columns={EQUIPMENT_COLUMNS}
          cards={EQUIPMENT_CARDS}
          minTableWidth={EQUIPMENT_MIN_TABLE_WIDTH}
          noun="equipment"
        />
      );
    }
    // A failed request; an empty result is handled by the table itself.
    if (isError && !isLoading) {
      content = <DataList.LoadError noun="equipment" onRetry={() => this.props.equipmentStore.loadEquipments()} />;
    }
    if (!isError && !isLoading) {
      content = <EquipmentsTable />
    }
    return (
      <div>
        <Helmet>
          <title>Equipment | FieldNexus</title>
        </Helmet>
        <PageWrapGray>
        <Sticky enabled={true} top={0} innerZ={9}>
          <SearchBars.Equipment key={this.props.viewStore.listFiltersVersion} />
        </Sticky>
        
          <Card>
            {content}
          </Card>
        
        </PageWrapGray>
      </div>
    )
  }

};

export default EquipmentsIndexPage;